import React from 'react';
import Card from '../../ui/Card';

const PALETTE = {
  // OS
  iOS: 'bg-blue-500',
  iPadOS: 'bg-blue-400',
  Android: 'bg-emerald-500',
  Windows: 'bg-sky-500',
  macOS: 'bg-neutral-700',
  Linux: 'bg-amber-500',
  ChromeOS: 'bg-yellow-500',
  // Browsers
  Safari: 'bg-blue-500',
  Chrome: 'bg-emerald-500',
  Firefox: 'bg-orange-500',
  Edge: 'bg-cyan-500',
  Opera: 'bg-red-500',
  'Samsung Internet': 'bg-indigo-500',
  'MIUI Browser': 'bg-amber-500',
  'Facebook In-App': 'bg-blue-600',
  'Instagram In-App': 'bg-pink-500',
  // Device types
  mobile: 'bg-emerald-500',
  tablet: 'bg-blue-500',
  desktop: 'bg-neutral-700',
  // Leave reasons
  voluntary: 'bg-neutral-500',
  'closed-tab': 'bg-amber-500',
  backgrounded: 'bg-blue-500',
  'network-lost': 'bg-red-500',
  'connection-error': 'bg-red-600',
  'removed-by-trainer': 'bg-purple-500',
  unknown: 'bg-neutral-400',
};

const labelize = (key) => {
  if (!key) return 'Unknown';
  if (key === 'mobile') return 'Mobile';
  if (key === 'tablet') return 'Tablet';
  if (key === 'desktop') return 'Desktop';
  return key.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
};

/**
 * Reusable horizontal-bar chart. Used 3+ times on the monitor page (OS,
 * browser, leave-reason). Passes through unknown keys with a neutral color.
 */
const DeviceMixChart = ({ title, mix, total, emptyMessage = 'No data yet' }) => {
  const entries = Object.entries(mix || {})
    .filter(([, v]) => v > 0)
    .sort((a, b) => b[1] - a[1]);
  const sum = total || entries.reduce((s, [, v]) => s + v, 0);

  return (
    <Card padding="md">
      <h3 className="text-sm font-semibold text-neutral-700 mb-4">{title}</h3>
      {entries.length === 0 ? (
        <p className="text-xs text-neutral-400 italic">{emptyMessage}</p>
      ) : (
        <div className="space-y-2.5">
          {entries.map(([key, count]) => {
            const pct = sum > 0 ? Math.round((count / sum) * 100) : 0;
            const color = PALETTE[key] || 'bg-neutral-400';
            return (
              <div key={key}>
                <div className="flex items-center justify-between mb-1">
                  <span className="text-xs text-neutral-700">{labelize(key)}</span>
                  <span className="text-xs font-medium text-neutral-900 tabular-nums">
                    {count} <span className="text-neutral-400">· {pct}%</span>
                  </span>
                </div>
                <div className="w-full bg-neutral-100 rounded-full h-1.5">
                  <div className={`h-1.5 rounded-full ${color} transition-all`} style={{ width: `${pct}%` }} />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Card>
  );
};

export default DeviceMixChart;
